
import { ApiBase } from "../api.js";
import { DomainParameters } from "../types/api/domains.js";

export class ApiDomains extends ApiBase {
	async create(data: unknown): Promise<unknown> {
		const result = await this.api.post('/domains/create', data);
		return result.data;
	}

    async read(data: DomainParameters): Promise<unknown> {
        const result = await this.api.get('/domains/get-all', {
            params: {
                ...data
            }
        });
        return result.data;
    }


	async readOne(id: string): Promise<unknown> {
		const result = await this.api.get(`/domains/get/${id}`);
		return result.data;
	}

	async update(id: string, data: unknown): Promise<unknown> {
		const result = await this.api.put(`/domains/update/${id}`, data);
		return result.data;
	}

	async upload(id: string, data: unknown): Promise<unknown> {
		const result = await this.api.put(`/domains/upload-screenshorts/${id}`, data, {
			headers: { 'Content-Type': 'multipart/form-data', Accept: '*/*' }
		});
		return result.data;
	}

	async deleteImage(id: string, data: unknown): Promise<unknown> {
		const result = await this.api.post(`/domains/delete-image/${id}`, data);
		return result.data;
	}

	async remove(id: string): Promise<unknown> {
		const result = await this.api.delete(`/domains/remove/${id}`);
		return result.data;
	}

	async clone(data: unknown): Promise<unknown> {
		const result = await this.api.post(`/domains/clone`,data);
		return result.data;
	}

	async export(data: unknown): Promise<unknown> {
		const result = await this.api.post(`/domains/export`,data);
		return result.data;
	}

	async domainStatus(id: string, data: {status: string}): Promise<unknown> {
		const result = await this.api.post(`/domains/update-status/${id}`,data);
		return result.data;
	}
	
}
